import type { DetailSectionStateProps } from "./types-detail-section-state";
import { useDetailSectionState } from "./use-detail-section-state";
import { DetailSectionStateView } from "./view-detail-section-state";

export function DetailSectionState(props: DetailSectionStateProps) {
  const vm = useDetailSectionState(props);

  return <DetailSectionStateView {...vm} />;
}

export type * from "./types-detail-section-state";
